<template>
  <div class="vertical-layout" :class="$slots['footer-fixed'] ? 'vertical-layout-pb' : ''">
    <slot></slot>
    <div class="footer-btn" v-if="$slots['footer-btn']">
      <slot name="footer-btn"></slot>
    </div>
    <div class="footer-btn-fixed" v-if="$slots['footer-fixed']">
      <slot name="footer-fixed"></slot>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  },
  mounted () {
    console.log(this.$slots)
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/function_px.less";
.footer-btn:not(:empty) {
  .footer-btn;
}
// 垂直布局
.vertical-layout {
  height: 100%;
  background-color: #f0f1f5;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  overflow: auto;
  display: flex;
  flex-direction: column;
}
.vertical-layout-pb {
  padding-bottom: 48px;
}
// 固定底部按钮
.footer-btn-fixed {
  position: fixed;
  bottom: 0;
  width: 100%;
  width: 10rem;
  .scale-iphoneX-fixed;
  div{
    height: 48px;
    line-height: 48px;
    font-size: 16px;
    font-weight: bold;
    color: white;
    background: #41a3ff;
    text-align: center;
  }
}
</style>
